// extracted by mini-css-extract-plugin
export var blue = "_1w-f";
export var brand = "_1w-b";
export var darkGrey = "_1w-e";
export var disabled = "_1w-4";
export var disabledSubtle = "_1w-5";
export var error = "_1w-6";
export var green = "_1w-g";
export var grey = "_1w-d";
export var icon = "_1w-0";
export var inherit = "_1w-a";
export var lightGrey = "_1w-c";
export var orange = "_1w-i";
export var pink = "_1w-k";
export var primary = "_1w-1";
export var purple = "_1w-l";
export var red = "_1w-j";
export var secondary = "_1w-2";
export var success = "_1w-9";
export var tertiary = "_1w-3";
export var warning = "_1w-7";
export var warningSecondary = "_1w-8";
export var white = "_1w-m";
export var yellow = "_1w-h";